export default __webpack_public_path__ + "static/media/glitch22.2a45f53d.png";